import Repository, {baseUrl} from './Repository';

export async function generateWebSession() {
    const endPoint = `/user/webSession`;

    return await Repository.post(`${baseUrl}${endPoint}`, null)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function generateASANSession() {
    const endPoint = `/user/ASANSession/web`;

    return await Repository.post(`${baseUrl}${endPoint}`, null)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function checkASANSession(transaction) {
    const endPoint = `/user/ASANCheckSession/${transaction}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userLogin(phone, password) {
    const endPoint = `/user/login`;
    const formData = new FormData()
    formData.append('login', phone);
    formData.append('password', password);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userForget(phone) {
    const endPoint = `/user/forget`;
    const formData = new FormData()
    formData.append('login', phone);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userForgetVerify(phone, otp) {
    const endPoint = `/user/reset`;
    const formData = new FormData()
    formData.append('login', phone);
    formData.append('otp', otp);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userSetPassword(token, password) {
    const endPoint = `/user/setPassword`;
    const formData = new FormData()
    formData.append('password', password);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userRegister(phone, email, name, surname, countryCode) {
    const endPoint = `/user/register`;
    const formData = new FormData()
    formData.append('phone', phone);
    formData.append('email', email);
    formData.append('name', name);
    formData.append('surname', surname);
    formData.append('countryCode', countryCode);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function otpVerify(token, otp) {
    const endPoint = `/user/verifyPhone`;
    const formData = new FormData();
    formData.append('otp', otp);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function requestVerification(token, file) {
    const endPoint = `/user/requestVerification`;
    const formData = new FormData();
    formData.append('file', file);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getGeneralSettings() {
    const endPoint = `/general/statistics`;

    return await Repository.get(`${baseUrl}${endPoint}`,)
        .then(response => {
            if (response.data) {
                return response.data.statistics;
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getAdvice(id, token) {
    const endPoint = `/general/tip?id=${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data.advices;
            } else {
                return null;
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return null;
        });
}

export async function getAdvices(token) {
    const endPoint = `/general/tips`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.advices;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function userMe(token) {
    const endPoint = `/user/me`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userAccounts(token) {
    const endPoint = `/profile/accounts`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.profiles;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function userSetAccount(token, companyId, profileType, accountType) {
    const endPoint = `/profile/account`;

    const formData = new FormData()
    formData.append('companyId', companyId);
    formData.append('profileType', profileType);
    formData.append('type', accountType);

    return await Repository.postForm(`${baseUrl}${endPoint}`, {
        companyId: companyId,
        profileType: profileType,
        type: accountType
    }, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function userSetFCMToken(token, fcm) {
    const endPoint = `/user/fcm`;

    const formData = new FormData()
    formData.append('fcm', fcm);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function readAllNotifications(token, id) {
    const endPoint = `/notifications/readAll?id=${id}`;


    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getAnnouncements(token) {
    const endPoint = `/general/announcements`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.announcements;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function getAnnouncement(token, id) {
    const endPoint = `/general/announcement/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function voteAnnouncement(token, id, answers) {
    const endPoint = `/general/announcement/${id}/vote?answers=${answers}`;

    return await Repository.post(`${baseUrl}${endPoint}`, {}, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getPage(token, pageLink, locale) {

    const endPoint = `/general/help?page=${pageLink}&languageCode=${locale ?? 'az'}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getDashboard(token, locale) {
    const endPoint = `/dashboard`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getSearchResult(token, keyword) {
    const endPoint = `/search?keyword=${keyword}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getSector(token, id, locale) {
    const endPoint = `/sector/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getSectorArchive(token, id) {
    const endPoint = `/sectorArchive/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getRequestsByType(token, type) {
    const endPoint = `/requests/${type}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getMyRequests(token, status) {
    const endPoint = `/myRequests?status=${status === 'ALL' ? '' : status}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getMyConversations(token) {
    const endPoint = `/conversations/my`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getMyNotifications(token, page) {
    const endPoint = `/notifications?page=${page}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data;
                } else if (response.data.code === 401) {
                    window.location.reload();
                } else {
                    return response.data;
                }
            }
            return {code: 1000, message: response.statusText};
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getConversationDetails(token, id) {
    const endPoint = `/conversation/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getFavoriteRequests(token, status) {
    const endPoint = `/favorites?draft=${status === 'draft' ? 1 : 0}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getCustomerRequests(token) {
    const endPoint = `/request/myCustomer`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function searchCompany(token, legalForm, taxId) {
    const endPoint = `/company/search?legalForm=${legalForm}&taxId=${taxId}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function generateOtp(email, token) {
    const endPoint = "/otp/email";
    return await Repository.get(`${baseUrl}${endPoint}?to=${email}`, {
        headers: {
            token: token
        }
    }).then(response => {
            if (response.data) {
                return response.data
            } else {
                return {code: 1000, message: response.statusText}
            }
        }
    ).catch(error => {
        console.log(JSON.stringify(error));
        return {code: 1001, message: error.message}
    });
}

export async function generateOtpCompany(email, token) {
    const endPoint = "/otp/email/company-confirm";
    return await Repository.get(`${baseUrl}${endPoint}?to=${email}`, {
        headers: {
            token: token
        }
    }).then(response => {
            if (response.data) {
                return response.data
            } else {
                return {code: 1000, message: response.statusText}
            }
        }
    ).catch(error => {
        console.log(JSON.stringify(error));
        return {code: 1001, message: error.message}
    });
}

export async function verifyOtp(receiver, otp, token) {
    const endPoint = "/otp/verify";
    return await Repository.get(`${baseUrl}${endPoint}?receiver=${receiver}&otp=${otp}`, {
        headers: {
            token: token
        }
    }).then(response => {
        if (response.data) {
            return response.data
        } else {
            return {code: 1000, message: response.statusText}
        }
    }).catch(error => {
        console.log(JSON.stringify(error));
        return {code: 1001, message: error.message}
    });
}

export async function verifyOtpCompanyEmail(receiver, otp, token, company) {
    const endPoint = "/otp/verify";
    return await Repository.get(`${baseUrl}${endPoint}?receiver=${receiver}&otp=${otp}&id=${company}`, {
        headers: {
            token: token
        }
    }).then(response => {
        if (response.data) {
            return response.data
        } else {
            return {code: 1000, message: response.statusText}
        }
    }).catch(error => {
        console.log(JSON.stringify(error));
        return {code: 1001, message: error.message}
    });
}

export async function addAdmin(userId, companyId, token) {
    const endPoint = "/user/make-admin";
    console.log("token: ", token)
    return await Repository.post(`${baseUrl}${endPoint}?userId=${userId}&companyId=${companyId}`, {}, {
        headers: {
            token: token
        }
    }).then(() => ({code: 1000}))
        .catch(error => ({code: 1001, message: error.message}));
}

export async function getCompanyById(token, id) {
    const endPoint = `/company/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getCompanyProfile(token, id, profile) {
    const endPoint = `/company/${id}/profile/${profile}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function applyCompanyProfile(token, id, profile, position) {
    const endPoint = `/company/${id}/apply`;

    const formData = new FormData()
    formData.append('position', position);
    formData.append('profileType', profile);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function changePosition(token, position) {
    const endPoint = `/company/position`;

    const formData = new FormData()
    formData.append('position', position);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function createCompany(token, legalForm, taxId, name, format, sectors, email, taxPhoto, countryCode) {
    const endPoint = `/company`;

    const formData = new FormData()
    formData.append('companyFormat', format);
    formData.append('legalForm', legalForm);
    formData.append('name', name);
    formData.append('taxId', taxId);
    formData.append('workingSectors', sectors);
    if (email) {
        formData.append("email", email)
    }
    if (taxPhoto) {
        formData.append("tinPicUrl", taxPhoto.join(','))
    }
    if (countryCode) {
        formData.append("companyCountryCode", countryCode)
    }

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function createPersonalCompany(token, position, profileType, sectors) {
    const endPoint = `/personalCompany`;

    const formData = new FormData()
    formData.append('profileType', profileType);
    formData.append('position', position);
    formData.append('workingSectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function deleteAccount(token, reason) {
    const endPoint = `/user/deleteAccount`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function changeEmail(token, email) {
    const endPoint = `/user/setEmail`;

    const formData = new FormData()
    formData.append('email', email);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function changeCompanyDetail(token, param, value) {
    const endPoint = `/company/details`;

    const formData = new FormData()
    formData.append('param', param);
    formData.append('value', value);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function changeCompanySectors(token, sectors) {
    const endPoint = `/company/sectors`;

    const formData = new FormData()
    formData.append('sectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function companyUserAction(token, companyUserId, action, reason) {
    const endPoint = `/companyUser/${companyUserId}/${action}`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function changeCompanyUserSectors(token, sectors) {
    const endPoint = `/company/profileSectors`;

    const formData = new FormData()
    formData.append('sectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function changeCompanyUserSectorsAdd(token, sectors) {
    const endPoint = `/company/profile/addSector`;

    const formData = new FormData()
    formData.append('sectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function createProfile(token, companyId, profileData, profileType, position) {
    const endPoint = `/company/profile`;

    const formData = new FormData()
    formData.append('companyId', companyId);
    formData.append('profileData', profileData);
    formData.append('profileType', profileType);
    formData.append('position', position);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function saveProfile(token, companyId, profileData, profileType) {
    const endPoint = `/company/profile`;

    const formData = new FormData()
    formData.append('companyId', companyId);
    formData.append('profileData', profileData);
    formData.append('profileType', profileType);

    return await Repository.putForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function leaveCompanyProfile(token) {
    const endPoint = `/company/leave`;


    return await Repository.postForm(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getCompanyDetails(token, id) {
    const endPoint = `/company/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getCompanyUserSectors(token) {
    const endPoint = `/company/profileSectors`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getCompanyBoard(token) {
    const endPoint = `/company/board`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getMyRatingHistory(token, page) {
    const endPoint = `/points/my?page=${page}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data.history;
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getCompanyUsers(token) {
    const endPoint = `/company/users`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getCompanyProfiles(token, id) {
    const endPoint = `/company/${id}/profiles`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getPurchases(token) {
    const endPoint = `/myPurchases`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getSales(token) {
    const endPoint = `/mySales`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getOffers(token) {
    const endPoint = `/myOffers`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function rateOffer(token, id, rate, comment) {
    const endPoint = `/request/${id}/rate`;

    const formData = new FormData()
    formData.append('rate', rate);
    formData.append('comment', comment);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function setWinnerAmount(token, id, amount) {
    const endPoint = `/winner/${id}/amount`;

    const formData = new FormData()
    formData.append('amount', amount);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getInfoBlockList(block, languageId) {
    const endPoint = `/blocks?block=${block}&languageId=${languageId}`;

    return await Repository.get(`${baseUrl}${endPoint}`)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getWorkingSectors(locale) {
    const endPoint = `/general/working-sectors`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.workingSectors;
                }
            }
            return [];
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function searchWorkingSector(keyword) {
    const endPoint = `/offline/sectorSearch?keyword=${keyword}`;

    return await Repository.get(`${baseUrl}${endPoint}`)
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.workingSectors;
                }
            }
            return [];
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getRequestDetails(token, id) {
    const endPoint = `/request/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getRequestFaq(token, id) {
    const endPoint = `/request/${id}/faq`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.faq;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function getRequestPrices(token, id) {
    const endPoint = `/request/prices/?requestId=${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.prices;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function getRequestWinners(token, id) {
    const endPoint = `/request/${id}/winners`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.winners;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getRequestParticipants(token, id) {
    const endPoint = `/request/${id}/participants`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.participants;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function getRequestUpdates(token, id, lastCommentId) {
    const endPoint = `/request/${id}/updates?lastCommentId=${lastCommentId}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });

}


export async function createRequest(token,
                                    requestType,
                                    requestSubType,
                                    workingSector,
                                    title, requestFiles,
                                    description,
                                    requestDeadline,
                                    isPrivate,
                                    requestIsPersonalAllowed,
                                    onlyVerified,
                                    onlyVendor,
                                    extras,
                                    products,
                                    pollAnswerList,
                                    vendorIds,
                                    autoWinner) {
    const endPoint = `/request`;

    const formData = new FormData()
    formData.append('requestType', requestType);
    formData.append('requestSubType', requestSubType);
    formData.append('requestSectors', workingSector);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('requestDeadline', requestDeadline);
    formData.append('isPrivate', isPrivate > 0);
    formData.append('isPersonalAllowed', requestIsPersonalAllowed > 0);
    formData.append('onlyVerified', onlyVerified > 0);
    formData.append('onlyVendors', onlyVendor > 0);
    formData.append('extras', extras);
    formData.append('pollAnswerList', pollAnswerList.join(','));
    formData.append('from', 'web');
    if (autoWinner)
        formData.append("autoWinner", autoWinner);


    if (vendorIds && vendorIds.length > 0) {
        vendorIds.forEach((vendorId) => {
            formData.append("vendorIds[]", vendorId);
        })
    }

    if (products && products.length > 0) {

        products.forEach((product, i) => {

            formData.append('requestProducts[' + i + '].productType', product.productType);
            formData.append('requestProducts[' + i + '].name', product.name);
            formData.append('requestProducts[' + i + '].note', product.note);
            formData.append('requestProducts[' + i + '].count', product.count);
            formData.append('requestProducts[' + i + '].photo', product.photo);
            formData.append('requestProducts[' + i + '].unit', product.unit);
            if (product.specialRequirements && product.specialRequirements.length > 0) {
                product.specialRequirements.forEach((req, reqIndex) => {
                    formData.append(`requestProducts[${i}].requirements[${reqIndex}]`, req.text);
                });
            }
        });

    }

    if (requestFiles && requestFiles.length > 0) {

        requestFiles.forEach((file, i) => {

            formData.append('requestFiles[' + i + '].id', file.id);
            formData.append('requestFiles[' + i + '].path', file.path);
            formData.append('requestFiles[' + i + '].type', file.type);
        });

    }

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function createRequestFromExcel(token, path) {
    const endPoint = `/requestFromExcel`;

    const formData = new FormData()
    formData.append('path', path);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function editRequest(token, requestId, workingSector, title, requestFiles, description, requestDeadline, isPrivate, requestIsPersonalAllowed, onlyVerified, onlyVendors, extras, autoWinner) {
    const endPoint = `/request/${requestId}/edit`;

    const formData = new FormData()
    formData.append('requestSectors', workingSector);
    formData.append('title', title);

    formData.append('description', description);
    formData.append('requestDeadline', requestDeadline || '');
    formData.append('isPrivate', isPrivate > 0);
    formData.append('isPersonalAllowed', requestIsPersonalAllowed > 0);
    formData.append('onlyVerified', onlyVerified > 0);
    formData.append('onlyVendors', onlyVendors > 0);
    formData.append('autoWinner', autoWinner);
    formData.append('extras', extras);

    if (requestFiles && requestFiles.length > 0) {

        requestFiles.forEach((file, i) => {

            formData.append('requestFiles[' + i + '].id', file.id);
            formData.append('requestFiles[' + i + '].path', file.path);
            formData.append('requestFiles[' + i + '].type', file.type);
        });

    }

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function createProduct(token, requestId, productType, name, count, photo, unit, note, extras) {
    const endPoint = `/request/${requestId}/product`;

    const formData = new FormData()
    formData.append('name', name);
    formData.append('productType', productType);
    formData.append('count', count);
    formData.append('unit', unit);
    formData.append('note', note);
    formData.append('extras', extras);
    if (photo) {
        formData.append('photo', photo);
    }


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function createPollAnswer(token, requestId, text) {
    const endPoint = `/request/${requestId}/pollAnswer`;

    const formData = new FormData()
    formData.append('text', text);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function editProduct(token, productId, productType, name, count, photo, unit, note, extras) {
    const endPoint = `/product/${productId}`;

    const formData = new FormData()
    formData.append('name', name);
    formData.append('productType', productType);
    formData.append('count', count);
    formData.append('unit', unit);
    formData.append('note', note);
    formData.append('extras', extras);
    if (photo) {
        formData.append('photo', photo);
    }


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function deleteProduct(token, productId) {
    const endPoint = `/product/${productId}/delete`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function deletePollAnswer(token, productId) {
    const endPoint = `/pollAnswer/${productId}/delete`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function submitPollAnswer(token, requestId, answerList, ownAnswers) {
    const endPoint = `/vote`;

    const formData = new FormData()
    formData.append('requestId', requestId);

    if (answerList && answerList.length > 0) {
        answerList.forEach((answer, i) => {
            formData.append('answerIds[' + i + ']', answer);
        });
    }
    if (ownAnswers && ownAnswers.length > 0) {
        ownAnswers.forEach((answer, i) => {
            formData.append('ownVariants[' + i + ']', answer);
        });
    }


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function prolongRequest(token, requestId, requestDeadline) {
    const endPoint = `/request/${requestId}/prolong`;

    const formData = new FormData()
    formData.append('requestDeadline', requestDeadline);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function askFaqQuestion(token, requestId, question) {
    const endPoint = `/request/ask`;

    const formData = new FormData()
    formData.append('requestId', requestId);
    formData.append('question', question);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function sendPrice(token, requestId, price) {
    const endPoint = `/request/sendPrice`;

    const formData = new FormData()
    formData.append('requestId', requestId);
    formData.append('price', price);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function answerFaqQuestion(token, faqId, answer, file) {
    const endPoint = `/request/${faqId}/answer`;

    const formData = new FormData()
    formData.append('answer', answer);
    formData.append('file', file);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function rejectFaqQuestion(token, faqId, reason) {
    const endPoint = `/request/${faqId}/rejectQuestion`;

    const formData = new FormData()
    formData.append('reason', reason);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function blockRequestUser(token, faqId, reason) {
    const endPoint = `/request/${faqId}/blockUser`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function unBlockRequestUser(token, faqId) {
    const endPoint = `/request/${faqId}/unBlockUser`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function sendComment(token, requestId, isPrivate, replyId, comment, photo, commentType, commentData) {
    const endPoint = `/request/${requestId}/comment`;

    const formData = new FormData()
    if (photo) {
        formData.append('photo', photo);
    }
    formData.append('type', commentType);
    formData.append('private', isPrivate);
    formData.append('replyId', replyId);
    formData.append('text', comment);
    formData.append('commentData', commentData);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function favoriteRequest(token, requestId) {
    const endPoint = `/request/${requestId}/favorite`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function unFavoriteRequest(token, requestId) {
    const endPoint = `/request/${requestId}/favorite`;

    return await Repository.delete(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function publishRequest(token, requestId) {
    const endPoint = `/request/${requestId}/publish`;


    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function closeRequest(token, requestId, isSuccess, note, winners) {
    const endPoint = `/request/${requestId}/close`;

    const formData = new FormData()
    formData.append('isSuccess', isSuccess);
    formData.append('note', note);
    formData.append('winners', winners.join(','));

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function deleteRequest(token, requestId) {
    const endPoint = `/request/${requestId}/delete`;


    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function reportComment(token, commentId, reason) {
    const endPoint = `/comment/${commentId}/report`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function startConversation(token, commentId) {
    const endPoint = `/conversation?commentId=${commentId}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function startAuctionConversation(token, requestId) {
    const endPoint = `/conversation/auction?requestId=${requestId}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function startOfferConversation(token, requestId) {
    const endPoint = `/conversation/offer?requestId=${requestId}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function startNewOfferConversation(token, requestId, requestUserId) {
    const endPoint = `/conversation/offer/new?requestId=${requestId}&requestUserId=${requestUserId}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function exportRequestResult(token, requestId, format) {
    const endPoint = `/request/${requestId}/excel?format=${format}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function exportRequestResultPrice(token, requestId, format, locale) {
    const endPoint = `/request/${requestId}/only-price?format=${format}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function exportRequestResultDetailed(token, requestId, format, locale) {
    const endPoint = `/request/${requestId}/detailed-report?format=${format}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function sendConversationMessage(token, conversationId, messageType, message, messageData) {
    const endPoint = `/conversation/${conversationId}/message`;

    const formData = new FormData()
    formData.append('type', messageType);
    formData.append('text', message);
    formData.append('messageData', messageData);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function closeConversation(token, conversationId, result, reason) {
    const endPoint = `/conversation/${conversationId}/close`;

    const formData = new FormData()
    formData.append('result', result);
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function removeProfilePhoto(token) {
    const endPoint = `/profile/photo`;


    return await Repository.delete(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function updateProfilePhoto(token, path) {
    const endPoint = `/profile/photo`;
    let formData = new FormData();

    formData.append("path", path);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function upload(token, type, file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);
    formData.append("type", type);

    return await Repository.post(`${baseUrl}/user/upload`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "token": token
        },
        onUploadProgress
    }).then(response => {
        return response;
    }).catch(error => {
        console.log(JSON.stringify(error));
        return {data: {code: 2, message: error.message}};
    });
}


export async function removeCompanyLogo(token) {
    const endPoint = `/company/logo`;


    return await Repository.delete(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function updateCompanyLogo(token, path) {
    const endPoint = `/company/logo`;
    let formData = new FormData();

    formData.append("path", path);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function updateCompanyLogoById(token, path, id) {
    const endPoint = `/company/logo/` + id;
    let formData = new FormData();
    console.log()
    formData.append("path", path);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function sendFeedbackRequest(token, appVersion, deviceInfo, text) {
    const endPoint = `/feedback`;

    const formData = new FormData()
    formData.append('appVersion', appVersion);
    formData.append('deviceInfo', deviceInfo);
    formData.append('text', text);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getFeedbacks(token) {
    const endPoint = `/feedback/my`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getCompanyRatingStatistics(token, id, profileType) {
    const endPoint = `/company/${id}/rating/${profileType}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getCompanyRatingList(token, id, profileType, rate) {
    const endPoint = `/company/${id}/reviews/${profileType}/${rate}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.purchases;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}

export async function getCompanyActivityStatistics(token, id, profileType) {
    const endPoint = `/company/${id}/activityRating/${profileType}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data;
                } else {
                    return {code: 1000, message: "error"};
                }
            } else {
                return {code: 1000, message: "error"};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1000, message: "error"};
        });
}


export async function getInvoices(token, lang) {
    const endPoint = `/invoices`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: lang
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getMyPackage(token, locale) {
    const endPoint = `/myPackage`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getPackages(token, packageType) {
    const endPoint = `/packages?platform=web&packageType=${packageType}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function activatePackage(token, period) {
    const endPoint = `/package?periodId=${period.id}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                console.log(response)
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function cancelPackage(token) {
    const endPoint = `/package/unsubscribe`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function reactivatePackage(token) {
    const endPoint = `/package/resubscribe`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function activateAddon(token, period) {
    const endPoint = `/addOn?periodId=${period.id}`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function cancelAddOn(token) {
    const endPoint = `/addOn/unsubscribe`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function reactivateAddOn(token) {
    const endPoint = `/addOn/resubscribe`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getVendorManagementStatus(token) {
    const endPoint = `/vendorManagement`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function sendPQTOffer(token, requestId, prices) {
    const endPoint = `/request/sendOffer`;

    const formData = new FormData()
    formData.append('requestId', requestId);


    Object.keys(prices.prices).forEach((productId, i) => {

        formData.append('prices[' + i + '].productId', productId);
        formData.append('prices[' + i + '].price', prices.prices[productId]);

        if (prices.techSpecs[productId]) {
            formData.append(`prices[${i}].techSpecification`, prices.techSpecs[productId]);
            if (prices.techSpecsFiles[productId])
                formData.append(`prices[${i}].techSpecsFiles`, prices.techSpecsFiles[productId]);
        }

        // Append special requirements details for each product
        if (prices.requirements[productId]) {
            Object.keys(prices.requirements[productId]).forEach((reqId, reqIndex) => {
                const detail = prices.requirements[productId][reqId];
                formData.append(`prices[${i}].requirements[${reqIndex}].id`, reqId);
                formData.append(`prices[${i}].requirements[${reqIndex}].detail`, detail);
            });
        }
    });

    let extras = {
        "valid": prices.valid,
        "techSpecification": prices.techSpecification,
        "delivery": prices.delivery,
        "payment": prices.payment,
        "files": prices.files.join(",")
    }

    formData.append('extras', JSON.stringify(extras))
    console.log('FormData contents:');
    for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
    }
    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function checkNewsletterStatus(email) {
    const endPoint = `/user/newsletter?email=${email}`;

    return await Repository.get(`${baseUrl}${endPoint}`)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function setNewsletterStatus(email, status) {
    const endPoint = `/user/newsletter?email=${email}&status=${status}`;

    return await Repository.post(`${baseUrl}${endPoint}`)
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}


export async function getSectorCompanyList(token, sectorId, profileType) {
    const endPoint = `/sectorCompanies/${sectorId}/${profileType}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.companies;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return [];
        });
}


export async function setRequestCoWorker(token, requestId, userId) {
    const endPoint = `/request/${requestId}/coWorker?userId=${userId}`;

    const formData = new FormData()
    formData.append('userId', userId);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}
